<template>
  <div>
    <div class="flex justify-between bg-gray-academy-900 shape h-70 boxShadow3d">
      <div class="w-5/12 bgImage">
        <div class="bg-background-academy bg-opacity-50 w-full h-full flex flex-col items-center
          justify-center">
          <span class="text-white border-b-2 border-orange-academy-150 w-2/3 text-2xl pb-3
            font-black z-10 opacity-100 flex justify-center">
            {{ masterclass.teacher.name }}
          </span>
          <masterclass-date class="text-white pt-4" :masterclass="masterclass" />
          <div class="flex justify-center mt-10">
            <router-link class="bg-white text-orange-academy-150 uppercase py-2 px-5 rounded text-sm
              border border-orange-academy-150 hover:bg-orange-academy-150 hover:text-white"
              :to="'/masterclasses/'+masterclass.id">
              {{ $t('masterclass.seeMore') }}
            </router-link>
          </div>
        </div>
      </div>
      <div class="w-2/3">
        <img class="object-cover w-full h-70 md-image"
        :src="masterclass.teacher.urlProfilePhoto" />
      </div>
    </div>
  </div>
</template>

<script>
import MasterclassDate from './MasterclassDate.vue';

export default {
  props: ['masterclass'],

  components: {
    MasterclassDate,
  },
};
</script>

<style scoped>

 .bgImage{
   background-image: url('/images/piano.jpg');
 }

.boxShadow3d{
    box-shadow: 1px 1px 0px #999,
                2px 2px 0px #999,
                3px 3px 0px #999,
                4px 4px 0px #999,
                5px 5px 0px #999,
                6px 6px 0px #999;
  }
</style>
